export function getRecordsForPageNumber<T>(pageNumber: number, perPage: number, records?: T[]) {
    return records?.slice((pageNumber - 1) * perPage, perPage * pageNumber)
}

export function getPagesCount<T>(perPage: number, records?: T[]) {
    return Math.ceil((records?.length || 0) / perPage)
}
